<template>
    <div class="layer-content common">
    	<!-- 이용약관 -->
        <div class="term-box">
            <!--<div class="term-tit1">제1장 총 칙</div>-->
            <div class="term-tit2">제1조(목적)</div>
            <div class="term-txt1">본 약관은 (주)에이티엔 (이하 "회사")이 제공하는 위치정보사업 또는 위치기반서비스사업과 관련하여 회사와 개인위치정보주체와의 권리, 의무 및 책임사항, 기타 필요 사항 규정을 목적으로 합니다.</div>

            <div class="term-tit2">제 2 조 (약관 외 준칙)</div>
            <div class="term-txt1">이 약관에 명시되지 않은 사항은 위치정보의 보호 및 이용 등에 관한 법률, 정보통신망 이용촉진 및 정보보호 등에 관한 법률, 전기통신기본법, 전기통신사업법 등 관계법령과 회사의 이용약관 및 개인정보처리방침, 회사가 별도로 정한 지침 등에 의합니다</div>

            <div class="term-tit2">제 3 조 (서비스 내용 및 요금)</div>
          <div class="term-txt1">기본 : 20인 이하 11,000원, 31~40인 22,000원, 40~80인 33,000, 81인 이상 44,000원<br/>(추가1대당 6,600원 합산)</div>
            <ol>
                <li>① 회사는 아래와 같은 방법으로 위치정보를 수집합니다. NFC태그 인식기를 설치한 장소의 위치정보를 수집하고, 해당 인식기에 NFC태깅 시 원아 및 시간정보를 수집합니다.</li>
                <li>② 회사는 직접 위치정보를 수집하거나 위치기반 서비스사업자에게 위치정보를 전달하여 아래와 같은 서비스를 제공합니다.
                    <ol>
                        <li>1. 어린이집 등하원 서비스: 원아 등하원 정보를 인식할 수 있는 기기의 위치정보를 저장합니다. </li>
                        <li>2. 위치정보를 활용한 출결 서비스: 등하원 정보 인식 기기에 태깅된 원아의 정보와 등하원 시간 정보를 저장하고, 보육통합정보시스템에 전송합니다.</li>
                    </ol>
                </li>
            </ol>

            <div class="term-tit2">제 4 조 (개인위치정보주체의 권리)</div>
            <ol>
                <li>① 개인위치정보주체는 개인위치정보 수집 범위 및 이용약관의 내용 중 일부 또는 개인위치정보의 이용ㆍ제공 목적, 제공받는 자의 범위 및 위치기반서비스의 일부에 대하여 동의를 유보할 수 있습니다.</li>
                <li>② 개인위치정보주체는 개인위치정보의 수집ㆍ이용ㆍ제공에 대한 동의의 전부 또는 일부를 철회할 수 있습니다.</li>
                <li>③ 개인위치정보주체는 언제든지 개인위치정보의 수집ㆍ이용ㆍ제공의 일시적인 중지를 요구할 수 있습니다. 이 경우 회사는 요구를 거절하지 아니하며, 이를 위한 기술적 수단을 갖추고 있습니다.</li>
                <li>④ 개인위치정보주체는 회사에 대하여 아래 자료의 열람 또는 고지를 요구할 수 있고, 당해 자료에 오류가 있는 경우에는 그 정정을 요구할 수 있습니다. 이 경우 회사는 정당한 이유 없이 요구를 거절하지 아니합니다.
                    <ol>
                        <li>1. 개인위치정보주체에 대한 위치정보 수집ㆍ이용ㆍ제공사실 확인자료</li>
                        <li>2. 개인위치정보주체의 개인위치정보가 위치정보의 보호 및 이용 등에 관한 법률 또는 다른 법령의 규정에 의하여 제3자에게 제공된 이유 및 내용</li>
                    </ol>
                </li>
                <li>⑤ 회사는 개인위치정보주체가 동의의 전부 또는 일부를 철회한 경우에는 지체 없이 수집된 개인위치정보 및 위치정보 수집ㆍ이용ㆍ제공사실 확인자료를 파기합니다. 단, 동의의 일부를 철회하는 경우에는 철회하는 부분의 개인위치정보 및 위치정보 수집ㆍ이용ㆍ제공사실 확인자료에 한합니다.</li>
                <li>⑥ 개인위치정보주체는 제1항 내지 제4항의 권리행사를 위하여 이 약관 제13조의 연락처를 이용하여 회사에 요구할 수 있습니다.</li>
            </ol>

            <div class="term-tit2">제 5 조 (법정대리인의 권리)</div>
            <ol>
                <li>① 회사는 만14세 미만 아동으로부터 개인위치정보를 수집ㆍ이용 또는 제공하고자 하는 경우에는 만14세 미만 아동과 그 법정대리인의 동의를 받아야 합니다.</li>
                <li>② 법정대리인은 만14세 미만 아동의 개인위치정보를 수집ㆍ이용ㆍ제공에 동의하는 경우 동의유보권, 동의철회권 및 일시중지권, 열람ㆍ고지요구권을 행사할 수 있습니다.</li>
            </ol>

            <!--<div class="term-tit1">제2장 서비스 이용계약 </div>-->
            <div class="term-tit2">제 6 조 (위치정보 이용ㆍ제공사실 확인자료 보유근거 및 보유기간)</div>
            <div class="term-txt1">위치정보의 보호 및 이용 등에 관한 법률 제16조 제2항에 근거하여 개인위치정보주체에 대한 위치정보 수집ㆍ이용ㆍ제공사실 확인자료를 위치정보시스템에 자동으로 기록하며, 6개월 이상 보관합니다.</div>

            <div class="term-tit2">제 7 조 (서비스의 변경 및 중지)</div>
            <ol>
                <li>① 회사는 위치정보사업자의 정책변경 등과 같이 회사의 제반 사정 또는 법률상의 장애 등으로 서비스를 유지할 수 없는 경우, 서비스의 전부 또는 일부를 제한, 변경하거나 중지할 수 있습니다.</li>
                <li>② 제1항에 의한 서비스 중단의 경우에는 회사는 사전에 인터넷 등에 공지하거나 개인위치정보주체에게 통지합니다.</li>
            </ol>

            <div class="term-tit2">제 8 조 (개인위치정보 제3자 제공 시 즉시 통보)</div>
            <ol>
                <li>① 회사는 개인위치정보주체의 동의 없이 당해 개인위치정보주체의 개인위치정보를 제3자에게 제공하지 아니하며, 제3자 제공 서비스를 제공하는 경우에는 제공 받는 자 및 제공목적을 사전에 개인위치정보주체에게 고지하고 동의를 받습니다.</li>
                <li>② 회사는 개인위치정보를 개인위치정보주체가 지정하는 제3자에게 제공하는 경우에는 개인위치정보를 수집한 당해 통신단말장치로 매회 개인위치정보주체에게 제공받는 자, 제공일시 및 제공목적을 즉시 통보합니다.</li>
                <li>③ 다만, 아래에 해당하는 경우에는 개인위치정보주체가 미리 특정하여 지정한 통신단말장치 또는 전자우편주소 등으로 통보합니다.
                    <ol>
                        <li>1. 개인위치정보를 수집한 당해 통신단말장치가 문자, 음성 또는 영상의 수신기능을 갖추지 아니한 경우</li>
                        <li>2. 개인위치정보주체가 개인위치정보를 수집한 당해 통신단말장치 외의 통신단말장치 또는 전자우편주소 등으로 통보할 것을 미리 요청한 경우</li>
                    </ol>
                </li>
            </ol>

            <div class="term-tit2">제 9 조 (8세 이하의 아동 등의 보호의무자의 권리)</div>
            <ol>
                <li>① 회사는 아래의 경우에 해당하는 자(이하 “8세 이하의 아동”등이라 한다)의 보호의무자가 8세 이하의 아동 등의 생명 또는 신체보호를 위하여 개인위치정보의 이용 또는 제공에 동의하는 경우에는 본인의 동의가 있는 것으로 봅니다.
                    <ol>
                        <li>1. 8세 이하의 아동</li>
                        <li>2. 금치산자</li>
                        <li>3. 장애인복지법제2조제2항제2호의 규정에 의한 정신적 장애를 가진 자로서 장애인고용촉진및직업재활법 제2조제2호의 규정에 의한 중증장애인에 해당하는 자(장애인복지법 제29조의 규정에 의하여 장애인등록을 한 자에 한한다)</li>
                    </ol>
                </li>
                <li>② 8세 이하의 아동 등의 생명 또는 신체의 보호를 위하여 개인위치정보의 이용 또는 제공에 동의를 하고자 하는 보호의무자는 서면동의서에 보호의무자임을 증명하는 서면을 첨부하여 회사에 제출하여야 합니다.</li>
                <li>③보호의무자는 8세 이하의 아동 등의 개인위치정보 이용 또는 제공에 동의하는 경우 개인위치정보주체 권리의 전부를 행사할 수 있습니다.</li>
            </ol>

            <!--<div class="term-tit1">제3장 계약당사자의 의무  </div>-->
            <div class="term-tit2">제 10 조 (손해배상)</div>
            <div class="term-txt1">개인위치정보주체는 회사의 위치정보의 보호 및 이용 등에 관한 법률 제15조 내지 26조의 규정을 위반한 행위로 손해를 입은 경우에 회사에 대하여 손해배상을 청구할 수 있습니다. 이 경우 회사는 고의 또는 과실이 없음을 입증하지 아니하면 책임을 면할 수 없습니다.</div>

            <div class="term-tit2">제 11 조 (분쟁의 조정)</div>
            <ol>
                <li>① 회사는 위치정보와 관련된 분쟁에 대하여 개인위치정보주체와 협의가 이루어지지 아니하거나 협의를 할 수 없는 경우에는 방송통신위원회에 재정을 신청할 수 있습니다.</li>
                <li>② 회사 또는 개인위치정보주체는 위치정보와 관련된 분쟁에 대해 당사자간 협의가 이루어지지 아니하거나 협의를 할 수 없는 경우에는 개인정보보호법에 따라 개인정보분쟁조정위원회에 조정을 신청할 수 있습니다.</li>
            </ol>

            <!--<div class="term-tit1">제4장 서비스 이용 </div>-->
          <div class="term-tit2">제 12 조 (이용약관의 공개 등)</div>
          <ol>
            <li>① 다음 각 호의 어느 하나에 해당하는 자는 그가 제공하려는 서비스의 내용, 위치정보의 수집ㆍ이용
              제공에 관한 요금 및 조건 등(이하 “이용약관”이라 한다)을 해당 사업자의 인터넷 홈페이지에 게시하는 등
              대통령령으로 정하는 방법에 따라 개인위치정보주체 및 위치기반서비스사업을 이용하는 자가 언제든지 쉽게 알아볼 수 있도록 공개하여야 하며,
              이를 변경하려는 경우에는 그 이유 및 변경내용을 대통령령으로 정하는 방법에 따라 지체 없이 공개하고, 변경된 사항을 쉽게 알아볼 수 있도록 조치하여야 한다.</li>
            <ol>
              <li>1. 위치정보사업자</li>
              <li>2. 제9조 제1항에 따라 위치기반서비스사업의 신고를 한 자 및 제9조의2 제1항에 따라 위치기반서비스사업을 하는 자(이하 “위치기반서비스사업자”라 한다)</li>
            </ol>
          </ol>

          <div class="term-tit2">제 13 조 (개인위치정보의 보육목적 및 보유기간)</div>
          <ol>
            <li>① 개인위치정보의 보유 목적은,  서비스를 이용하는 "어린이집"에게 어린이 안심 등.하원 알림 서비스를 제공하는데 그 목적이 있다.
              <ol>
                <li>1. 서비스내역</li>
                <li>등하원 알림, 전자출결, 예상 연장 보육료 확인, 알림장, 투약의뢰, 귀가동의서, 식단표, 공지사항, 고객지원</li>
              </ol>
            </li>
            <li>② 보유기간
              <ol>
                <li>계약일로부터 10년간</li>
              </ol>
            </li>
          </ol>

          <!-- 2022.11.25 이용약관 변경 요청
          <div class="term-tit2">제 13 조 (개인위치정보의 이용 또는 제공)</div>
          <div class="term-txt1">(개인위치정보의 이용 또는 제공)①위치기반서비스사업자가 개인위치정보를 이용하여 서비스를 제공하고자 하는 경우에는 미리 다음 각호의 내용을 이용약관에 명시한 후 개인위치정보주체의 동의를 얻어야 한다.</div>
          <ol>
            <li>1. 위치기반서비스사업자의 상호, 주소, 전화번호 그 밖의 연락처</li>
            <li>2. 개인위치정보주체 및 법정대리인(제25조 제1항에 따라 법정대리인의 동의를 얻어야 하는 경우로 한정한다)의 권리와 그 행사방법</li>
            <li>3. 위치기반서비스사업자가 제공하고자 하는 위치기반서비스의 내용</li>
            <li>4. 위치정보이용ㆍ제공사실 확인자료의 보유근거 및 보유기간 <br>
              4의2. 개인위치정보의 보유목적 및 보유기간</li>
            <li>5. 그 밖에 개인위치정보의 보호를 위하여 필요한 사항으로서대통령령으로 정하는 사항</li>
          </ol>
          -->

          <div class="term-tit2">제 14 조 (사업자 정보)</div>
            <div class="term-txt1">회사의 상호, 주소, 전화번호 그 밖의 연락처는 다음과 같습니다.</div>
            <ol>
                <li>상호: (주)에이티엔</li>
                <li>주소: 경기도 이천시 마장면 덕평로 771-10</li>
                <li>전화번호: 031-637-6368</li>
            </ol>

            <div class="term-tit2">부 칙 </div>
            <div class="term-tit2">제 1 조 시행일</div>
            <div class="term-txt1">2020년 2월 17일부터 시행합니다.</div>

            <div class="term-tit2">제 2 조 위치정보관리 책임자 정보</div>
            <div class="term-txt1">회사는 다음과 같이 위치정보 관리책임자를 지정하여 이용자들이 서비스 이용과정에서 발생한 민원사항 처리를 비롯하여 개인위치정보주체의 권리 보호를 위해 힘쓰고 있습니다.</div>
            <ol>
                <li>위치정보 관리책임자 : 김명욱 운영 본부장</li>
                <li>전화번호 : 1661-5029</li>
                <li>이메일 주소 : atn@newatn.co.kr</li>
            </ol>
        </div>
	</div>
</template>

<script>
    export default {
        name : 'tosAgreePopup',
        data : function(){
            return {
            }
        },
        methods: {
        },
    }
</script>